<template>
  <div class="cssPak" >
    <div class="celdaGuia">
      <h4 class="transformed">{{ `Guia: ${Envio.NoGuia}` }}</h4>
    </div>
    <div class="cssContenido">
      <b-row class="py-1">
        <b-col class="px-1">
          <div class="ml-2 mx-2">
            <router-link to="/courier/home">
              <img src="/logo4.svg" />
            </router-link>
          </div>
        </b-col>
        <b-col @click="siguiente" class="p-0 text-center">
          <h3 style="line-height:30px" class="py-0 my-0">{{ Envio.Destinatario.Region }}</h3>
          <h3 style="line-height:30px" class="py-0 my-0 bold">{{ Pak }}/{{ Paquetes.length }}</h3>
        </b-col>
        <b-col class="text-center"> <QrCode :value="Envio.NoGuia" level="H" renderAs="svg" size="60" /> </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col><b>Envia:</b></b-col>
        <b-col cols="10"> {{Envio.Remitente ? Envio.Remitente.Nombre : ''}} </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col><b> Recibe:</b></b-col>
        <b-col cols="10">
          <div class="tabla">
            <div @click="celVisible=!celVisible" class="celda">{{ Envio.Destinatario ? Envio.Destinatario.Nombre : '' }}</div>
            
            <div class="celda entrega">{{ Envio.Entrega.substring(0, 3) }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col><b> Celular:</b></b-col>
        <b-col cols="10"> 
          <h6 v-if="celVisible" class="my-0" v-html="Envio.Destinatario.Celular"></h6>
          <h6 v-else class="my-0">- - - -</h6>
          </b-col>
      </b-row>
      <b-row>
        <b-col class="espacio"><b>Direccion:</b> {{ Envio.Destinatario.Direccion }}</b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="espacio"><b>Contenido:</b> {{ MiContenido }}</b-col>
      </b-row>
      <b-row v-show="hayObservacion">
        <b-col><b>Observacion:</b> {{ Envio.Observacion }}</b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
//import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrCode: QrcodeVue,
  },
  methods: {
    siguiente() {
      if (this.Pak < this.Paquetes.length) {
        this.Pak++; 
      } else {
        this.Pak = 1;
        this.$emit("Reinicio");
        }
    },
  },
  computed: {
    hayObservacion() {
      return !!this.Envio.Observacion; 
    },
    Fecha() {
      var t = new Date(1970, 0, 1); 
      t.setSeconds(this.Envio.Fecha.seconds);
      return t.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
    },
    MiContenido() {
      let rs = this.Paquete.map((c) => {
        return c.Cantidad + " " + c.Producto;
      });
      return rs.join(", ");
    },
    Paquetes() {
      let d = this.Envio.Contenido.filter((env) => {
        return env.Tipo == "Paquete";
      });
      return d;
    },
    Paquete() {
      let d = this.Paquetes[this.Pak - 1];
      return d.Contenido;
    },
  },
  beforeCreate() {
    this.$root.$emit("Imprimir", { ok: true });
  },
  created() {
    this.Pak = this.pak || 1;
  },
  props: ["pak","Envio"],
  data() {
    return {
      celVisible:true,
      Pak: null,
    };
  },
};
</script>

<style scoped>
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 3px solid black;
  margin: 1em 0;
  padding: 0;
}
.cssPak {
  display: table;
  height: 7cm;
  width: 12cm;
}
.cssContenido{
 display: table-cell;
  border: 1px solid #aaa;
  padding: 2px;
}
hr {
  margin: 0px;
}
.bold {
  font-weight: 700;
}
.label {
  width: 200px !important;
}
.row {
  font-size: 14px;
}
.espacio {
  line-height: 16px;
}

.tabla {
  display: table;
  width: 100%;
}
.celda {
  display: table-cell;
}
.entrega {
  table-layout: fixed;
  width: 1.5cm;
  font-weight: 800;
}
.transformed {
  transform: rotate(270deg);
  transform-origin: 0% 30%;
  position: absolute;
  top: 240px;
  left: 5px;
}
.celdaGuia {
  display: table-cell;
  height: 240px;
  width: 30px;
  background-color: #bbb;
  border: 1px solid black;
}
</style>
